
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conjure/policies/dmca",
      function () {
        return require("private-next-pages/conjure/policies/dmca.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conjure/policies/dmca"])
      });
    }
  